import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { Overlay } from '@angular/cdk/overlay';

import { AutocompleteTokensFieldComponent } from './autocomplete-tokens-field.component';
import { TokenItem } from './tokens-field.component';
import { UsersService } from '../users/users.service';
import { User } from '../users/user.model';

@Component({
  selector: 'app-users-field',
  templateUrl: './autocomplete-tokens-field.component.html',
  styleUrls: ['./autocomplete-tokens-field.component.scss']
})
export class UsersFieldComponent extends AutocompleteTokensFieldComponent {

  @Input() recipients: User[] = [];

  debounce: number = 400;
  pattern: string = "^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$";
  subscription: Subscription;
  
  constructor(
    cd: ChangeDetectorRef,
    overlay: Overlay,
    private usersService: UsersService ) { super(cd, overlay); }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.subscription != null) {this.subscription.unsubscribe()}
  }

  loadSuggestions(value) {
    if (this.subscription != null) {this.subscription.unsubscribe()}
    if (value != null && value.trim() !== '' && !/,/.test(value)) {
      this.subscription = this.usersService.search(value).subscribe(
        (users) => {
          this.suggestions = users.slice(0,8).map((u) => {
            return {
              stored: u,
              displayed: ''+u.name,
              secondary: u.email
            };
          })
          if (this.suggestions.length > 0) {
            this.selectedIndex = 0;
            this.showSuggestions();
          }
          this.loading = false;
          this.cd.markForCheck();
        },
        (errors) => {this.loading = false; this.cd.markForCheck();}
      )
    } else if (/,/.test(value)) {
      this.commitValue();
    } else {
      this.loading = false;
      this.cd.markForCheck();
    }
  }

  validateItem(item) {
    let email = item.value.stored.email;
    if (this.patternRegex.test(email)) {
      item.loading = true;
      this.usersService.search(email, 1).subscribe(
        (users) => {
          if (users.length > 0) {
            let user = users[0];
            item.value = {
              stored: user,
              displayed: user.name,
              secondary: user.email
            };
            item.toolTip = user.email != null ? user.email.toLowerCase() : null;
            item.valid = true;
            this.validate();
            this.emitValue();
          }
          item.loading = false;
          this.cd.markForCheck();
        },
        (error) => {
          item.loading = false;
          this.cd.markForCheck();
        }
      )
    }
  }

  itemValuesEqual(a,b): boolean {
    a = a != null ? a.stored : null;
    b = b != null ? b.stored : null;
    if (a == null || b == null) {
      return a == b;
    } else { // Comparing users or lists
      return (''+a.id).caseInsensitiveCompare(''+b.id)
    }
  }

  itemFromControlValue(value: string): TokenItem {
    value = value.trim();
    let item = new TokenItem();
    let user = new User({
      id: value,
      email: value
    });
    item.value = {
      stored: user,
      displayed: user.email
    };
    return item;
  }

  commitValue() {
    if (this.subscription != null) {this.subscription.unsubscribe()}
    this.loading = false;
    this.cd.markForCheck();
    if (this.suggestions.length > 0) {
      this.commitSelected();
    } else {
      if (this.control.value != null) {
        let values = this.control.value.split(/[,;\s]/);
        for (let value of values) {
          if (value != null && value.trim() !== '') {
            let item = this.itemFromControlValue(value);
            this.validateItem(item);
            this.addItem(item);
          }
        }
        this.control.setValue('');
      }
    }
  }

  commitSelected() {
    let index = this.autocomplete != null ? this.autocomplete.selectedIndex : null;
    if (index != null) {
      let suggestion = this.suggestions[index];
      let item = new TokenItem();
      item.value = {
        stored: suggestion.stored,
        displayed: suggestion.displayed
      };
      item.toolTip = suggestion.secondary;
      item.valid = true;
      this.addItem(item);
    }
    this.control.setValue('');
    this.clearSuggestions();
  }

  loadItems(values?: any[]): TokenItem[] {
    let items = super.loadItems(values);
    for (let item of items) {
      let stored = item.value.stored;
      if (typeof stored == "string") {
        item.valid = this.recipients.find((r) => { return stored.toLowerCase() == r.id.toLowerCase(); }) != null;
      } else if (stored != null && stored.email != null) {
        let user = new User(stored);
        item.value.stored = user;
        item.toolTip = user.email.toLowerCase();
        item.valid = this.recipients.find((r) => { return user.id === r.id; }) != null;
      }
    }
    return items;
  }

}


// WEBPACK FOOTER //
// ./src/app/forms/users-field.component.ts